import { ErrorQueryHandler } from 'src/components/error/error-query-handler.component'
import { useTranslation } from 'react-i18next'
import { useCurrentProject } from 'src/providers/current-project.provider'
import { useQuery } from '@tanstack/react-query'
import { MedicalStaffMemberService } from 'src/services/medical-staff-member.service'
import MedicalStaffMemberList from './_components/medical-staff-members-table.component'
import { CurecallButton, ECurecallButtonAppearance } from '@honestica/curecall-ui'
import { useState } from 'react'
import MedicalStaffMemberFormModal from './_components/medical-staff-members-modal.component'
import { TMedicalStaffMember } from 'src/types/medical-staff-member'
import { ConfigurationHeaderWrapper } from '../_components/configuration-header-wrapper.component'
import { ProjectService } from 'src/services/project.service'
import AddOrUpdateUserModal from 'src/pages/medical/users/_components/add-or-update-user-modal.component'
import DeleteUserModal from 'src/pages/medical/users/_components/delete-user-modal.component'
import { TPermission } from '../permissions/_components/permissions.type'
import { TModalProps } from 'src/pages/medical/users/_components/users-table.component'

export default function Page() {
  const { project } = useCurrentProject()
  const { t } = useTranslation()

  const [isOpenModal, setIsOpenModal] = useState<boolean>(false)
  const [selectedMedicalStaffMember, setSelectedMedicalStaffMember] = useState<
    TMedicalStaffMember | undefined
  >(undefined)
  const [modalProps, setModalProps] = useState<TModalProps>(undefined)

  const {
    isLoading,
    error: queryError,
    data,
  } = useQuery({
    queryKey: ['medical-staff-member-list'],
    queryFn: () => MedicalStaffMemberService.getMedicalStaffMemberList(project.id),
  })
  const { data: projectPermissionList } = useQuery({
    queryKey: ['permissions'],
    queryFn: () => ProjectService.getPermissions(project.id),
  })

  if (queryError) {
    return <ErrorQueryHandler error={queryError} />
  }

  return (
    <ConfigurationHeaderWrapper title={t('pages.users-page.title-medical-staff-members')}>
      <header className="c-flex c-mb-6 c-justify-end">
        <CurecallButton appearance={ECurecallButtonAppearance.SECONDARY} onClick={() => setIsOpenModal(true)}>
          {t('pages.users-page.add-medical-staff-member')}
        </CurecallButton>
      </header>
      <div>
        <p className="c-font-nexa">{t('pages.users-page.title-medical-staff-members-description')}</p>
        <p className="c-font-nexa">{t('pages.users-page.title-medical-staff-members-sub-description')}</p>
      </div>
      <MedicalStaffMemberList
        medicalStaffMemberList={data}
        isLoading={isLoading}
        onActionHandle={(data: TMedicalStaffMember, action: 'UPDATE' | 'CREATE_USER') => {
          setSelectedMedicalStaffMember(data)
          if (action === 'UPDATE') {
            setIsOpenModal(true)
          } else {
            setModalProps({ mode: 'POST', UserProject: undefined })
          }
        }}
      />
      <MedicalStaffMemberFormModal
        onCancel={() => {
          setIsOpenModal(false)
          setSelectedMedicalStaffMember(undefined)
        }}
        isOpen={isOpenModal}
        selectedMedicalStaffMember={selectedMedicalStaffMember}
      />

      <AddOrUpdateUserModal
        modalProps={modalProps}
        setModalProps={setModalProps}
        projectPermissionList={projectPermissionList as TPermission[]}
      />

      <DeleteUserModal modalProps={modalProps} setModalProps={setModalProps} />
    </ConfigurationHeaderWrapper>
  )
}
